// @ngInject
function ReturnReasonsApiService(ResourcesService, DSHttpAdapter, DS, $q) {

  var endpoint = 'returnreasons';

  return {
    getReturnReasons: ResourcesService.apiFactory.get(endpoint),
    getReturnReason: ResourcesService.apiFactory.get(endpoint),
    getLocations: GetLocations,
    createReturnReason: ResourcesService.apiFactory.create(endpoint),
    updateReturnReason: ResourcesService.apiFactory.update(endpoint, 'ReturnReason'),
    deleteReturnReason: ResourcesService.apiFactory.delete(endpoint, 'ReturnReason')
  };

  function GetLocations() 
  {
    var deferred = $q.defer();

    DSHttpAdapter.GET(DS.defaults.basePath + "/returnreasons" + "/locations").then(function(response) {
        deferred.resolve(response);
    }, function(error) {
        deferred.reject(error);
    });

    return deferred.promise;

  }

}

angular
  .module('returnreasons.api', [])
  .factory('ReturnReasonsApiService', ReturnReasonsApiService);
